<template lang="pug" src="./templates/Comments.pug"></template>
<style lang="stylus" src="./styles/Comments.styl" scoped></style>

<script>
import Loader from '../../components/Loader';
import ReportCommentModal from '../../components/ReportCommentModal';

export default {
    components: { 
        Loader,
        ReportCommentModal
    },

    props: { dealID: Number },

    data() {
        return {
            newComment: '',
            isLoading: false,
            comments: [],
            modalOpen: false,
            commentToReport: {},
        };
    },

    async created() {
        this.getComments();
    },

    methods: {
        replyToComment(comment) {
            comment.reply = !comment.reply;
            this.$forceUpdate();
        },

        async submitReply(comment) {
            this.isLoading = true;
            await window.axios.post(
                `/api/deals/${this.$route.params.id}/comments/${comment.id}`,
                { comment: comment.replyText },
            );

            // Load new comments
            await this.getComments();
            this.isLoading = false;
        },

        async getComments() {
            this.isLoading = true;
            const response = await window.axios.get(`/api/deals/${this.$route.params.id}/comments`);
            this.comments = response.data.data;
            this.newComment = '';
            this.isLoading = false;
        },

        async submitComment() {
            this.isLoading = true;
            await window.axios.post(
                `/api/deals/${this.$route.params.id}/comments`,
                { comment: this.newComment },
            );

            // Load new comments
            await this.getComments();
            this.isLoading = false;
        },

        openReportModal(comment) {
            window.commentToReport = comment;
            this.commentToReport = comment;
            this.modalOpen = true;
        },

                
        /**
         * Like or unlike the deal
         */
        async likeComment(comment) {
            const likeOrUnlike = comment.liked ? 'unlike' : 'like';


            comment.isLoadingLike = true;
            const response = await window.axios.post(`/api/comments/${comment.id}/${likeOrUnlike}`);
            comment.isLoadingLike = false;

            if (response.status < 400) {
                comment.liked = !comment.liked;

                if (comment.liked) {
                    comment.likes += 1;
                } else {
                    comment.likes -= 1;
                }
            }
        },
    },
};
</script>
